import { Flex, List, Text } from "@mantine/core";
import { openModal } from "@mantine/modals";
import { MigrateError } from "src/generated/graphql";
import { successNotification } from "src/utils/alerts";
import { MESSAGES } from "src/utils/constants";

export function migrateErrors(errors: MigrateError) {
  // Function to check if any errors exist
  const hasErrors = Object.values(errors).some(
    (errorArray) => errorArray.length > 0
  );
  if (!hasErrors)
    return successNotification({ message: MESSAGES.UPLOADED_FILE });
  //Open Modal if exist error
  openModal({
    closeOnClickOutside: false,
    title: "Migration Errors",
    children: (
      <Flex direction={"column"} gap={"sm"}>
        {Object.keys(errors).map((errorKey: string, rowIndex) => {
          const errorArray = errors[errorKey as keyof MigrateError];
          if (Array.isArray(errorArray) && errorArray.length > 0) {
            return (
              <div key={rowIndex}>
                <Text fw={"bold"} size={"lg"} mb={3} underline>
                  {errorKey}:
                </Text>
                <List>
                  {errorArray.map((error: any, indx) => (
                    <List.Item key={indx}>{error}</List.Item>
                  ))}
                </List>
              </div>
            );
          }
          return null;
        })}
      </Flex>
    ),
  });
}
